import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", to: "/" },
    { name: "Products", to: "/products" },
    { name: "About", to: "/about" },
    { name: "Contact", to: "/contact" },
  ];

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-lg z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between py-4 px-6">
<h1 className="text-3xl font-extrabold tracking-wide 
  bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 
  bg-clip-text text-transparent uppercase drop-shadow-lg">
  MYSCHOOL <span className="text-yellow-400 drop-shadow-md">APP</span>
</h1>
        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 font-extrabold text-[16px]">
          {navItems.map((item) => {
            const active = location.pathname === item.to;

            return (
              <div key={item.to} className="relative">
                <Link
                  to={item.to}
                  className={`relative px-3 py-2 transition-all duration-300 ${
                    active
                      ? "text-blue-700"
                      : "text-gray-700 hover:text-blue-700"
                  }`}
                >
                  {/* Active Gradient Box */}
                  {active && (
                    <motion.div
                      layoutId="active-pill"
                      className="absolute inset-0 rounded-lg bg-gradient-to-br from-blue-500 via-purple-500 to-indigo-600 shadow-lg shadow-blue-300/40"
                      transition={{ duration: 0.25 }}
                    ></motion.div>
                  )}

                  {/* Text above gradient */}
                  <span className="relative z-10">{item.name}</span>
                </Link>
              </div>
            );
          })}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-3xl text-blue-700 focus:outline-none font-bold"
          onClick={() => setOpen(!open)}
        >
          {open ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Dropdown */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.25 }}
            className="md:hidden bg-white shadow-xl border-t border-gray-200"
          >
            <div className="px-6 py-3 flex flex-col gap-3">

              {navItems.map((item) => {
                const active = location.pathname === item.to;

                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={`py-3 px-4 rounded-lg font-extrabold text-[17px] transition-all ${
                      active
                        ? "bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-600 text-white shadow-lg shadow-blue-400/40 border border-blue-300"
                        : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                    }`}
                  >
                    {item.name}
                  </Link>
                );
              })}

            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}